// extracted by mini-css-extract-plugin
export default {"homeproduct__wrapper":"home_homeproduct__wrapper__H1Mkr","handwear__wrapper":"home_handwear__wrapper__1wRey"};